// @flow
import {childrenJson, commandJson} from 'components/proposals/Part/shared/changePayload'
import type {Change, State} from './types'

const accountabilityJson = commandJson('Accountability')
const domainJson = commandJson('Domain')

function changePayload(change: Change, state: State): { command: string } {
  const body = JSON.parse(change.command)
  const {accountabilities, destroy, domains, originalRole} = state

  const children = childrenJson(
    accountabilities.map(accountabilityJson),
    domains.map(domainJson),
  )

  const commandBody = {
    ...body,
    children,
    destroy,
    originalRoleDatabaseId: originalRole?.databaseId,
  }

  return {
    command: JSON.stringify(commandBody),
  }
}

export default changePayload
